module.exports = __webpack_public_path__ + "img/dialog-bg.3e70e3b0.png";